/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Root Imports
*/

import { Box } from '~/components/Widget';
import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { BoxInnerLinks } from './BoxInnerLinks';

/**
 * Exports
*/

/**
 * 
 */
export function ResourceManage(props) {
  /** Contexts **/
  
  const view = useContext(props.context);
  const request = useParams();
  
  /** States **/
  
  const [ resource, setResource ] = useState(null);
  const [ error, setError ] = useState(null);
  
  /** Constants **/

  const isLoading = !!( request.id && !resource && !error );
  
  /** Side-Effects **/

  useEffect(() => {
    handleChangeResource();
  }, [ request.id ]);
  
  /** Event Handlers **/

  /**
   * 
   */
  const handleChangeResource = () => {
    setResource(null);
    setError(null);

    if (request.id) {
      props.service(request)
        .then(response => setResource(response.data))
        .catch(error => setError(error.response.data))
      ;
    }
  };
  
  /** Renderers **/
  
  /**
   * 
   */
  const renderError = () => (
    props.renderError ? props.renderError(error)
      : <Fragment>
          <p>Error</p>
          <p>{ error.message }</p>
        </Fragment>
  );

  /**
   * 
   */
  const renderLoading = () => (
    props.renderLoading ? props.renderLoading() : null
  );
  
  /** Output **/

  return (
    <div className='flex'>
      <Box className='w-2/6 mr-2' padding={ 0 }>
        <BoxInnerLinks
          items={ view[props.group] }
          active={ resource }
          group={ props.group }
        />
      </Box>
      <Box className={ CssClassName([ 'w-4/6 ml-2', isLoading && 'loading' ]) }>
        {
          error ? renderError()
            : resource ? props.renderResource(resource)
            : !request.id ? props.renderIndex()
            : renderLoading()
        }
      </Box>
    </div>
  );
}

ResourceManage.propTypes = {
  group: PropTypes.string.isRequired,
  service: PropTypes.func.isRequired,
  context: PropTypes.object.isRequired
};